import Head from 'next/head';
import Layout from '../../components/Public/Layout';
import HomePart6 from "../../components/Home/Part6";
import Faq from "../../components/Public/mb/Faq";
import styles from './index1.module.scss';
import {getFaqList} from '../../lib/faq';
import {mmgaevent1} from '../../utils/ga';
import debounce from 'lodash.debounce';
import {useState, useEffect} from 'react';
//2021.7 的推广页，不用维护
export default function Home1() {
  const faq = getFaqList();
  const [faqList, setFaqList] = useState(faq);
  const handle = () => {
    let ele = document.querySelector('#home_banner');
    const elementHeight = ele.offsetHeight;
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > elementHeight) {
      console.log(document.querySelector('#footer_last'));
      console.log(document.querySelector('#footer'));
      document.querySelector('#footer').style.padding = '0 0 76px';
      document.querySelector('#footer_last').style.position = 'fixed';
      document.querySelector('#footer_last').style.bottom = '0';
      document.querySelector('#footer_last').style.left = '0';
      document.querySelector('#footer_last').style.zIndex = '22222';
    } else {
      document.querySelector('#footer').style.padding = '0';
      document.querySelector('#footer_last').style.position = 'unset';
    }
  };
  const debounceWrapper = debounce(handle, 30);
  useEffect(() => {
    window.addEventListener('scroll', debounceWrapper);
    return () => {
      window.removeEventListener('scroll', debounceWrapper);
    };
  });
  function handlePost(type) {
    if (type === 1) {
      mmgaevent1('p_Botton_click', 'p_Top_IOS_button');
    } else if (type === 2) {
      mmgaevent1('p_Botton_click', 'p_Top_And_button');
    }
  }
  const data1 = [
    {
      id: 1,
      title: 'Free Phone Number',
      desc:
        'Get a free phone number for WiFi calling and unlimited texts to US and CA.',
    },
    {
      id: 2,
      title: 'Online Calls to Any Line',
      desc:
        'Free online call to any mobile or landline with no sim card or cell plans needed.',
    },
    {
      id: 3,
      title: 'Text with a Real Number',
      desc:
        'Free online SMS, texts, voice and images on a real number from an app.',
    },
  ];
  const data2 = [
    {
      id: 1,
      Image: '/images/home/img_numbers1@2x.png',
      desc: 'Separate life and business Protect Your Private Number',
    },
    {
      id: 2,
      Image: '/images/home/img_earth@2x.png',
      desc: 'Enjoy Boundary Free International Calls & SMS',
    },
    {
      id: 3,
      Image: '/images/home/img_wifi@2x.png',
      desc:
        'Call to any mobile or landline with no sim card or cell plans needed',
    },
    {
      id: 4,
      Image: '/images/home/img_features1@2x.png',
      desc:
        'Boost business through calling such as voicemail, call forwarding, block call, etc.',
    },
  ];
  const data3 = [
    {
      id: 1,
      Image: '/images/home/icon_users@2x.png',
      title: '100M',
      desc: 'Users in 2019',
    },
    {
      id: 4,
      Image: '/images/home/icon_minutes@2x.png',
      title: '1,000M',
      desc: 'Yearly minutes',
    },
    {
      id: 5,
      Image: '/images/home/icon_messages@2x.png',
      title: '200M',
      desc: 'Yearly messages',
    },
    {
      id: 6,
      Image: '/images/home/icon_numbers@2x.png',
      title: '1,000K+',
      desc: 'Available numbers',
    },
  ];
  return (
    <div>
      <Head>
        <title>
          Unlimited Free Calling & Texting App with Second Phone Number -
          Dingtone
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0,user-scalable=no,viewport-fit=cover"
        />
        <meta
          name="description"
          content="Unlimited free calling & texting via WiFi or cellular data without using cell minutes. Call forwarding, voicemail, auto reply and spam call blocking features included. Get yourself a 2nd phone number from Dingtone!"></meta>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=UA-199932631-1"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
            
              gtag('config', 'UA-199932631-1');
            `,
          }}></script>
      </Head>
      <Layout>
        <div className={styles.home}>
          <div className={styles.banner} id="home_banner">
            <div>
              <h1>Protect Privacy via a Second Number</h1>
              <p>Call and Text Unlimitedly to Any Number</p>
              <h2>Free Download</h2>
              <div className={styles.download + ' ' + 'row1 jb'}>
                <a
                  href="https://app.adjust.com/42wpw7q"
                  onClick={() => handlePost(1)}>
                  <img src="/images/home/appstore@2x (1).png"></img>
                </a>
                <a
                  href="https://app.adjust.com/ridh9my"
                  onClick={() => handlePost(2)}>
                  <img src="/images/home/googleplay@2x (5).png"></img>
                </a>
              </div>
            </div>
            <img
              style={{margin: '40px 0'}}
              className={styles.pic}
              src="/images/home/img_privacy@2x.png"></img>
          </div>
          <div className={styles.content2}>
            <h2>Add a Second Line to Your Phone</h2>
            {data2.map((item, index) => {
              return (
                <div key={index} className={styles.content2__item}>
                  <img src={item.Image}></img>
                  <p>{item.desc}</p>
                </div>
              );
            })}
          </div>
          <div className={styles.content6}>
            <HomePart6 />
          </div>
          <div className={styles.content7}>
            <Faq/>
          </div>
        </div>
      </Layout>
    </div>
  );
}
